import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { zoomPlugin } from "@react-pdf-viewer/zoom";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";

import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useNavigate } from "react-router-dom";

import LoaderGIf from "../../../Assets/LoadingImage.gif";

const PDFViewer = ({ pdfUrl, loading, error }) => {
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

const defaultLayoutPluginInstance = defaultLayoutPlugin({
  renderToolbar: (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          Download,          
          ZoomIn,
          ZoomOut,
          GoToNextPage,
          GoToPreviousPage,
          CurrentPageInput,
          NumberOfPages,
        } = slots;

        return (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <GoToPreviousPage />
            <CurrentPageInput /> / <NumberOfPages />
            <GoToNextPage />
            <ZoomOut />
            <ZoomIn />
            {/* <Print /> */}
          </div>
        );
      }}
    </Toolbar>
  ),
});

  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const zoomPluginInstance = zoomPlugin();
  const { zoomTo } = zoomPluginInstance;

  // useEffect(() => {
  //   zoomTo(1.3);
  // }, [zoomTo]);

  const onDocumentLoad = (e) => {
    setNumPages(e.doc.numPages);
    setCurrentPage(0);
  };

  const handlePdfLoadError = (e) => {
    console.error("PDF load error:", e);
  };

  return (
    <div className="PDFPAPER custom-pdf-container">
   

      {loading ? (
        <div className="loader">
          <img src={LoaderGIf} alt="Loading PDF" />
        </div>
      ) : error ? (
        <div className="error">Failed to load PDF</div>
      ) : (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
          <Viewer
            fileUrl={pdfUrl}
            onDocumentLoad={onDocumentLoad}
            onError={handlePdfLoadError}
            plugins={[defaultLayoutPluginInstance, zoomPluginInstance]}
          />
        </Worker>
      )}
    </div>
  );
};

export default PDFViewer;